export const SAVE_TOKEN = 'SAVE_TOKEN';
export const REMOVE_TOKEN = 'REMOVE_TOKEN';
export const USER_SUBSCRIPTION = 'USER_SUBSCRIPTION';
export const SAVE_STATUS = 'SAVE_STATUS';